import { render, staticRenderFns } from "./collectOrder.vue?vue&type=template&id=fdefb986&scoped=true"
import script from "./collectOrder.vue?vue&type=script&lang=js"
export * from "./collectOrder.vue?vue&type=script&lang=js"
import style0 from "./collectOrder.vue?vue&type=style&index=0&id=fdefb986&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdefb986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdefb986')) {
      api.createRecord('fdefb986', component.options)
    } else {
      api.reload('fdefb986', component.options)
    }
    module.hot.accept("./collectOrder.vue?vue&type=template&id=fdefb986&scoped=true", function () {
      api.rerender('fdefb986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/collectOrder.vue"
export default component.exports